import { ComponentConfig } from "@zapier/builder.io-kit";
import dynamic from "next/dynamic";

export const pricingOptionsV2Config: ComponentConfig = {
  name: "PricingOptionsV2",
  friendlyName: "PricingOptions",
  category: "Pricing",
  canHaveChildren: true,
  includeScrollTracking: true,
  component: dynamic(() => import("./PricingOptionsV2")),
  inputs: [
    {
      name: "stateKey",
      type: "string",
      required: true,
      helperText:
        "An identifier that should match any other component(s) on the page that should be updated by interactions with this component.",
    },
    {
      name: "hideIntervalOptions",
      type: "boolean",
      helperText: "Hide the radio buttons and only show the currency selector.",
    },
  ],
};
